import { gtmService } from '../../../../utils/gtm.service';
import { Checkbox, TextField } from '@mui/material';
import { StepperButtons } from '../../brand/components/StepperButtons';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IRegisterAdmin } from '../../brand/dto/IRegister';
import { AgencyService } from '../service';
import { ErrorToast, SuccessToast, WarningToast } from '../../../../utils/toasters';
import { useRecaptcha } from '../../../../shared/hooks/useRecaptcha';
import { Form } from 'react-bootstrap';
import { InternalRoutes } from '../../../../enum/InternalRoutes';
import { PasswordVerifySteps } from '../../../../shared/PasswordVerifySteps';
import InputPassword from '../../../../shared/components/input/InputPassword';
import { IRegisterStepperProps } from '../../../../model/shared/IRegistration';

export const Step1 = ({ stepIdNumber, handleBackStep }: IRegisterStepperProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [currentAgency, setCurrentAgency] = useState<IRegisterAdmin>({
        email: '',
        password: '',
        isGeneralTermsAccepted: false,
        repeatPassword: '',
    });
    const { setToken, executeRecaptcha } = useRecaptcha();

    const changeHandler = (event: React.ChangeEvent<HTMLInputElement>, isCheckbox = false) => {
        const { name, value, checked } = event.target;
        setCurrentAgency(prev => ({
            ...prev,
            [name]: isCheckbox ? checked : value,
        }));
    };

    const handleNextStep = async () => {
        if (!executeRecaptcha) {
            return;
        }
        const result = await executeRecaptcha('register');
        setToken(result);
        if (currentAgency?.isGeneralTermsAccepted) {
            setIsLoading(true);
            AgencyService.registerAccount(currentAgency)
                .then(response => {
                    if (response) {
                        gtmService('influencer_management_lead');
                        navigate(
                            `${InternalRoutes.AGENCY_REGISTRATION}/${stepIdNumber + 1}?token=${
                                response?.verificationUUID
                            }`
                        );
                        SuccessToast(t('auth.register.brand.step1.pleaseCheckEmail'));
                    }
                })
                .catch(error => ErrorToast(error))
                .finally(() => setIsLoading(false));
        } else {
            WarningToast(t('auth.register.brand.step1.termsNotSelected'));
        }
    };
    return (
        <Form
            className="w-100"
            onSubmit={e => {
                e.preventDefault();
                handleNextStep();
            }}
        >
            <div className="row">
                <div className="col-md-6">
                    <TextField
                        label="E-mail"
                        variant="outlined"
                        size="small"
                        defaultValue={currentAgency?.email ?? ''}
                        required
                        type="email"
                        name="email"
                        onChange={changeHandler}
                        className="w-100 my-2"
                    />
                </div>
                <div className="col-md-6" />
                <div className="col-md-6">
                    <InputPassword
                        label={t('auth.register.brand.step1.password')}
                        name="password"
                        className="w-100 my-2"
                        onChange={changeHandler}
                        required
                    />
                    <PasswordVerifySteps password={currentAgency.password ?? ''} />
                </div>
                <div className="col-md-6">
                    <InputPassword
                        label={t('auth.register.brand.step1.repeatPassword')}
                        name="repeatPassword"
                        className="w-100 my-2"
                        onChange={changeHandler}
                        required
                    />
                </div>
                <div className="col-12 my-2 d-flex align-items-center">
                    <Checkbox
                        defaultChecked={currentAgency?.isGeneralTermsAccepted ?? false}
                        className="px-0"
                        onChange={e => {
                            changeHandler(e, true);
                        }}
                        size={'small'}
                        id="checkbox"
                        name="isGeneralTermsAccepted"
                        color="primary"
                    />
                    <label
                        htmlFor="checkbox"
                        className="ml-2 mb-0 text-start cursor-pointer"
                        dangerouslySetInnerHTML={{ __html: t('auth.register.brand.step1.terms') }}
                    />
                </div>
                <div className="col-12 mt-4">
                    <StepperButtons
                        currentStep={stepIdNumber - 1}
                        handleNextStep={handleNextStep}
                        isLoading={isLoading}
                        handleBackStep={handleBackStep}
                    />
                </div>
            </div>
        </Form>
    );
};
